import { gql } from '@apollo/client';

export const GET_DELIVERABLE_SUBMISSION_SIGNED_URL = gql`
  query getDeliverableSubmissionSignedUrl($serializedParams: String!) {
    getSignedUploadUrl(
      feature: "deliverableSubmission"
      serializedParams: $serializedParams
    ) {
      url
      s3RequestFields
      queryResponseFields
    }
  }
`;

export const GET_REPORTING_TEMPLATE_UPLOAD_SIGNED_URL = gql`
  query getReportingTemplateUploadSignedUrl($serializedParams: String!) {
    getSignedUploadUrl(
      feature: "getReportingTemplateUploadDestination"
      serializedParams: $serializedParams
    ) {
      url
      s3RequestFields
      queryResponseFields
    }
  }
`;

export const GET_RECEIVABLE_DOCUMENTATION_UPLOAD_SIGNED_URL = gql`
  query getReceivableDocumentationUploadSignedUrl($serializedParams: String!) {
    getSignedUploadUrl(
      feature: "getReceivableDocumentationUploadDestination"
      serializedParams: $serializedParams
    ) {
      url
      s3RequestFields
      queryResponseFields
    }
  }
`;

export const GET_ORG_PROVIDED_VALUES_SUPPLEMENTAL_UPLOAD_SIGNED_URL = gql`
  query getOrgProvidedValuesUploadDestination($serializedParams: String!) {
    getSignedUploadUrl(
      feature: "getOrgProvidedValuesUploadDestination"
      serializedParams: $serializedParams
    ) {
      url
      s3RequestFields
      queryResponseFields
    }
  }
`;
